import { render, staticRenderFns } from "./DiscountHomePage.vue?vue&type=template&id=35f6cbd7&scoped=true"
import script from "./DiscountHomePage.vue?vue&type=script&lang=js"
export * from "./DiscountHomePage.vue?vue&type=script&lang=js"
import style0 from "./DiscountHomePage.vue?vue&type=style&index=0&id=35f6cbd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6cbd7",
  null
  
)

export default component.exports